<template>
	<div ref="steps" class="fun_step">
		<!-- 第一步 -->
		<div class="step clear_both">
			<span class="num bg_theme">1</span>
			<div class="install_l">
				<h1 class="step_title">安装浏览器<i class="speed_logo"></i><i class="chrome_logo"></i></h1>
				<p class="detail">推荐安装360极速浏览器：<a class="text_theme text_underline" href="https://browser.360.cn/ee/" target="_blank">点击下载</a></p>
				<p class="detail">推荐安装谷歌浏览器：<a class="text_theme text_underline" href="https://www.google.cn/chrome/" target="_blank">点击下载</a></p>
			</div>
			<div class="install_r">
				<h3 class="title">视知觉学习治疗软件趣味版</h3>
				<div class="ways">
					<a class="way" href="https://training.uflyvision.com.cn/eaglefun/" target="_blank" style="margin-right: 30px;"><i class="pc_icon"></i>网页版</a>
					<a class="way" href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E8%B6%A3%E5%91%B3%E7%89%882.0%E5%AE%89%E8%A3%85%E5%8C%85win32.exe"><i class="download_icon"></i>电脑客户端</a>
				</div>
			</div>
		</div>
		<!-- 第一步 end -->
		
		<!-- 第二步 -->
		<div class="step">
			<span class="num bg_theme">2</span>
			<h1 class="step_name">登录及训练注意事项</h1>
			<div class="video_box">
				<video v-if="isLogin" ref="note_video" controls poster="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/quweiban.png">
					<source src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E7%99%BB%E5%BD%95%E5%8F%8A%E8%AE%AD%E7%BB%83%E5%87%86%E5%A4%87%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A1%B9%EF%BC%88%E8%B6%A3%E5%91%B3%E7%89%88%EF%BC%89.mp4" type="video/mp4">
					你的浏览器不支持video标签！！！
				</video>
				<img v-if="!isLogin" src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/quweiban.png" alt="">
				<div v-show="!noteVideo_play" class="mask" @click="handleNoteVideoPlay"><i></i></div>
			</div>
		</div>
		<!-- 第二步 end -->
	</div>
</template>

<script>
	import Login from '../../../../utils/login.js';
	
	export default {
		props: {
			scrollTop: {
				type: Number,
				default: 0
			}
		},
		mounted() {
			this.noteVideo_offsetTop = 0;
			this.isLogin = Login.checkLogin();
			this.getStepOffset();
			if (this.isLogin) {
				this.$nextTick(() => {
					this.initVideoOffsetTop();
					this.addVideoEvents();
				});
			}
		},
		beforeDestroy() {
			this.isLogin && this.removeVideoEvents();
		},
		data() {
			return {
				isLogin: false,
				noteVideo_play: false
			}
		},
		methods: {
			/*************** @Events *******************/
			// 登录及训练注意事项视频播放
			handleNoteVideoPlay() {
				if (this.isLogin) {
					this.$refs.note_video.play();
					this.noteVideo_play = true;
				} else {
					this.$router.push({path: '/index/login'});
				}
			},
			
			/*************** @Function *******************/
			// 获取每一步距离顶部的距离
			getStepOffset() {
				let steps = this.$refs.steps.children;
				let offsets = [];
				for (let i = 0;i < steps.length;i++) {
					i == 0 ? offsets.push(this.$refs.steps.offsetTop - 80) : offsets.push(steps[i].offsetTop + this.$refs.steps.offsetTop - 80);
				}
				offsets.push(this.$refs.steps.offsetTop + this.$refs.steps.offsetHeight - 80);
				this.$emit('emitOffsets', offsets);
			},
			// 初始化video距离顶部
			initVideoOffsetTop() {
				let noteVideo_offsetTop = this.$refs.note_video.parentElement.offsetTop + this.$refs.note_video.parentElement.parentElement.offsetTop + this.$refs.note_video.parentElement.parentElement.parentElement.offsetTop  + this.$refs.note_video.offsetHeight - 80;
				this.noteVideo_offsetTop = noteVideo_offsetTop;
			},
			// 给video添加事件
			addVideoEvents() {
				this.$refs.note_video.addEventListener('ended', this.noteVideoEnd, false);
			},
			// 移除video事件
			removeVideoEvents() {
				this.$refs.note_video.removeEventListener('ended', this.noteVideoEnd);
			},
			// 登录及注意事项视频播放完毕
			noteVideoEnd() {
				this.noteVideo_play = false;
			},
			// 当全屏视频出现时暂停视频播放
			pauseVideo() {
				this.noteVideo_play && this.$refs.note_video.pause();
			}
		},
		watch: {
			scrollTop(newVal) {
				if (newVal >= this.noteVideo_offsetTop && this.noteVideo_play) {
					this.$refs.note_video.pause();
				}
			}
		}
	}
</script>

<style scoped>
	.fun_step{ position: relative;width: 1200px;margin: 30px auto 0;padding: 68px 184px 98px 116px;border-radius: 10px;background: #fff;overflow: hidden; }
	.fun_step .step{ position: relative;padding: 0 0 60px 90px; }
	.fun_step .step:last-child{ padding-bottom: 0; }
	.fun_step .step::before{ content: "";display: block;position: absolute;width: 1px;height: 100%;top: 0;left: 23.5px;border-left: 1px dashed #2b53c6; }
	.fun_step .step .num{ display: block;position: absolute;width: 48px;height: 48px;top: 0;left: 0;border-radius: 50%;font-size: 26px;color: #fff;text-align: center;line-height: 48px; }
	.fun_step .install_l{ float: left; }
	.fun_step .install_l .detail{ margin-top: 10px;font-size: 18px;line-height: 36px; }
	.fun_step .install_r{ float: right;width: 350px;height: 130px;margin-top: 6px;padding: 20px 20px 0;background-image: url(../../../../assets/download_yellow_bg.png);background-size: 100% 100%; }
	.fun_step .install_r .title{ font-size: 20px;color: #020d28;text-align: center;line-height: 36px; }
	.fun_step .install_r .ways{ margin-top: 20px;font-size: 18px;text-align: center;line-height: 30px; }
	.fun_step .install_r .pc_icon{ display: inline-block;width: 23px;height: 21px;margin: 4.5px 10px 0 0;background-image: url(../../../../assets/pc_theme.png);vertical-align: top; }
	.fun_step .install_r .download_icon{ display: inline-block;width: 21px;height: 19px;margin: 5.5px 10px 0 0;background-image: url(../../../../assets/download_theme.png);vertical-align: top; }
	
	.fun_step .video_box{ position: relative;height: 375px;margin-top: 15px;border-radius: 5px;overflow: hidden; }
	.fun_step .video_box img{ display: block;position: absolute;top: 50%;left: 50%;max-width: 100%;transform: translate(-50%, -50%); }
	.fun_step .video_box video{ display: block;width: 100%;height: 100%; }
	.fun_step .video_box .mask{ position: absolute;width: 100%;height: 100%;top: 0;left: 0;background: rgba(0, 0, 0, 0.7);cursor: pointer; }
	.fun_step .video_box .mask i{ display: block;position: absolute;width: 60px;height: 60px;top: 50%;left: 50%;margin: -30px 0 0 -30px;background-image: url(../../../../assets/video_play.png);background-size: 100% 100%; }
	
	.fun_step .step .step_title{ font-size: 30px;font-weight: bold;line-height: 48px; }
	.fun_step .step .step_name{ font-size: 18px;line-height: 48px; }
	.fun_step .speed_logo{ display: inline-block;width: 34px;height: 34px;margin: 7px 0 0 15px;background-image: url(../../../../assets/360.png);background-size: 100% 100%;vertical-align: top; }
	.fun_step .chrome_logo{ display: inline-block;width: 34px;height: 34px;margin: 7px 0 0 15px;background-image: url(../../../../assets/chrome.png);background-size: 100% 100%;vertical-align: top; }
</style>
